import { ConfirmationDialog } from '@components/dialog/ConfirmationDialog';

export const LSIC_COMPANY_NAME = 'LIO Specialty Insurance Company';
export const LIC_COMPANY_NAME = 'LIO Insurance Company';

/** The carrier named in the acknowledgement depends on the quote's writing company. */
export const getIncompleteProposalCompanyName = (isLSIC: boolean): string =>
  isLSIC ? LSIC_COMPANY_NAME : LIC_COMPANY_NAME;

export const getIncompleteProposalNoticeText = (companyName: string): string =>
  `IMPORTANT NOTICE: THIS INDICATION REPRESENTS TERMS AND CONDITIONS BASED UPON THE INCOMPLETE INFORMATION PROVIDED TO US AT THIS TIME AND IS NOT AN OFFER OF INSURANCE BUT AN EXAMPLE OF POTENTIAL COVERAGE PROVIDED. BY CLICKING ACCEPT, YOU ACKNOWLEDGE THAT NO POLICY CAN BE BOUND UNTIL A COMPLETE AND FULLY EXECUTED ${companyName.toUpperCase()} - APPLICATION FOR INSURANCE IS PROVIDED TO US. YOU FURTHER ACKNOWLEDGE THAT THE TERMS OF THIS INDICATION ARE SUBJECT TO AND LIKELY WILL CHANGE BASED UPON THE INFORMATION PROVIDED TO US IN A COMPLETE ${companyName.toUpperCase()} - APPLICATION FOR INSURANCE.`;

export const getIncompleteProposalCheckboxText = (companyName: string): string =>
  `I have read the notice above and acknowledge the terms therein. I accept that the indication is an example of available coverage and is subject to change upon receipt by ${companyName} of additional information.`;

type IncompleteProposalNoticeModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  companyName: string;
  onClose: () => void;
  onAccept: () => void;
};

export const IncompleteProposalNoticeModal = ({
  isOpen,
  isLoading,
  companyName,
  onClose,
  onAccept,
}: IncompleteProposalNoticeModalProps) => {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onCancel={onClose}
      description={getIncompleteProposalNoticeText(companyName)}
      checkboxText={getIncompleteProposalCheckboxText(companyName)}
      isLoading={isLoading}
      buttonConfig={{
        confirmText: 'Accept and Download Indication',
        onConfirm: onAccept,
        secondaryText: 'Exit',
      }}
    />
  );
};
